import React from 'react';
import './heartIcon.scss';

const HeartIcon = (props) => {
    return (
       <div style={{ ...props.style,  position:'relative' }}>
         <img alt="Your donation is matched by us" src={props.src} style={{width: '35px',height: '20px'}} />
		</div>
    )
};

export default HeartIcon
